const utils = {
    //路径
    path: "",
    request: "",
    // api: 'https://act' + this.getPrefix() + 'etcchebao.com',
    // //load js or css
    loadFile: function(url, callback) {
        var elem;
        if (url.match(/\.js/i)) {
            elem = document.createElement("script");
            elem.src = url;
            document.body.appendChild(elem);
        } else {
            elem = document.createElement("link");
            elem.href = url;
            elem.rel = "stylesheet";
            document.head.appendChild(elem);
        }
        elem.onload = elem.onreadystatechange = function() {
            if (!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {
                if (callback) {
                    callback();
                }
            }
        };
    },
    issTel: function(Tel) {
        var re = new RegExp(/^1[34578]\d{9}$/);
        var retu = Tel.match(re);
        if (retu) {
            return true;
        } else {
            return false;
        }
    },
    // //cookie time:XX天
    setCookie: function(name, value, time) {
        var oDate = new Date();
        oDate.setDate(oDate.getDate() + time);
        document.cookie = name + "=" + value + ";expires=" + oDate;
    },
    getCookie: function(name) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("=");
            if (arr2[0] == name) {
                return arr2[1];
            }
        }
        return "";
    },
    getPrefix: function () { //截取当前host有没有后缀 如-dev 、-test等
        var wlh = window.location.host.toString();
        var prefix = '';
        if ( wlh.indexOf('-dev') !== -1 ) {
            prefix = '-dev';
        } else if ( wlh.indexOf('-test') !== -1  ) {
            prefix = '-test';
        } else {
            prefix = '';
        }
        return prefix;
    },
    removeCookie: function(name) {
        this.setCookie(name, "", 0);
    },
    queryString: function(key) {
        return (document.location.search.match(new RegExp("(?:^\\?|&)" + key + "=(.*?)(?=&|$)")) || ['', null])[1];
    },
    replacePhone: function(key) {
        return key.substr(0, 3) + '****' + key.substr(7);
    },
    urlpage: function() {
        return (location.href.replace(document.location.search, ""));
    },
    // //移动端环境判断
    ua: navigator.userAgent,
    url: window.location.href,
    // //分享
    isShare: function() {
        return this.url.match(/petShareFrom/i);
    },
    // //移动
    isMobile: function() {
        return this.ua.match(/AppleWebKit.*Mobile/i);
    },
    // //ios
    isIos: function() {
        return this.ua.match(/iPhone|iPod|iPad/i);
    },
    // //安卓
    isAndroid: function() {
        return this.ua.match(/Android/i);
    },
    // //微信
    isWeixin: function() {
        return this.ua.match(/MicroMessenger/i);
    },
    // //本地存储
    storage: {
        ls: window.localStorage,
        setItem: function() {
            return this.ls.setItem.apply(this.ls, arguments);
        },
        getItem: function() {
            return this.ls.getItem.apply(this.ls, arguments);
        },
        removeItem: function() {
            return this.ls.removeItem.apply(this.ls, arguments);
        },
        clear: function() {
            return this.ls.clear.apply(this.ls, arguments);
        }
    },
    // //对话框
    alert: function(obj, callback) {
        var content = obj.content || String(obj) || "",
            btnText = obj.btnText || "确定",
            boxClass = obj.boxClass || "",
            alertHtml = '\
                <div class="dialog ' + boxClass + '">\
                    <div class="dialog-box">\
                        <div class="j-btn-close"></div>\
                        <div class="dialog-detail">' + content + "" + '</div>\
                        <div class="dialog-opera">\
                            <button class="dialog-btn dialog-btn-close">' + btnText + '</button>\
                        </div>\
                    </div>\
                    <div class="dialog-overlay"></div>\
                </div>';
        //document.body.insertAdjacentHTML("beforeend", alertHtml);
        $(".dialog").remove();
        $("body").append(alertHtml);
        var dialog = $(".dialog"),
            btnClose = $(".dialog-btn-close");
        btnClose.on("click", function() {
            dialog.remove();
            if (callback) {
                callback();
            }
        });
        $('.j-btn-close').on("click", function() {
            dialog.remove();
            if (callback) {
                callback();
            }
        });
    },
    
    confirm: function(obj, callback) {
        var content = obj.content || String(obj) || "",
            okText = obj.okText || "确定",
            cancelText = obj.cancelText || "取消",
            boxClass = obj.boxClass || "",
            confirmHtml = '\
                <div class="dialog ' + boxClass + '">\
                    <div class="dialog-box">\
                    <div class="j-btn-close"></div>\
                        <div class="dialog-detail">' + content + "" + '</div>\
                        <div class="dialog-opera">\
                            <div class="dialog-btn dialog-btn-ok">' + okText + '</div>\
                            <div class="dialog-btn dialog-btn-cancel">' + cancelText + '</div>\
                        </div>\
                    </div>\
                    <div class="dialog-overlay"></div>\
                </div>';
        $(".dialog").remove();
        $("body").append(confirmHtml);
        var dialog = $(".dialog"),
            btnOk = $(".dialog-btn-ok"),
            btnCancel = $(".dialog-btn-cancel"),
            flag = true,
            oprea = function() {
                dialog.remove();
                if (callback) {
                    callback(flag);
                }
            };
        btnOk.on("click", function() {
            flag = true;
            oprea();
        });
        btnCancel.on("click", function() {
            flag = false;
            oprea();
        });
        $('.j-btn-close').on("click",function() {
            flag = false;
            oprea();
        });
    },
    prompt: function(obj, callback) {
        var content = obj.content || String(obj) || "",
            boxClass = obj.boxClass || "",
            delay = obj.delay || 2000,
            msgHtml = '<div class="dialog-prompt ' + boxClass + '">' + content + '</div>';
        $(".dialog-prompt").remove();
        $("body").append(msgHtml);
        var prompt = $(".dialog-prompt"),
            promptWidth = prompt.width();
        prompt.css({
            "margin-left": -promptWidth / 2
        });
        if (delay < 0) return;
        setTimeout(function() {
            prompt.css({
                "opacity": 0
            });
            setTimeout(function() {
                prompt.remove();
                if (callback) {
                    callback();
                }
            }, 500);
        }, delay);
    },
     gtVersion(curr,target){
        if(curr == target){
            return true;
        }else{
            curr = curr.split('.');
            target = target.split('.');
            for(var i = 0;i<curr.length;i++){
                if(parseInt(curr[i])>parseInt(target[i])){
                    return true;
                }else if(parseInt(curr[i])==parseInt(target[i])){
                     continue ;
                }else{
                    return false;
                    
                }
            }
        }
    },
    share: function(callback) {
        var msgHtml = '\
        <div class="dialog-share">\
            <div class="dialog-share-box">\
                <div></div>\
                <div></div>\
                <div></div>\
            </div>\
            <div class="dialog-share-overlay"></div>\
        </div>';
        $(".dialog-share").remove();
        $("body").append(msgHtml);
        var dialog = $(".dialog-share")
        dialog.on("click", function() {
            dialog.remove();
            if (callback) {
                callback();
            }
        });
    },
    /**
         * 显示等待
         *
         */
        showLoading: function (tips) {
            var htmls = '<div class="g-loading">'
                + '<div class="g-loading-bg"></div>'
                + '<div class="g-loading-body">'
                + '<div class="g-loading-str">' + (tips || '正在加载 ') + '</div>'
                + '</div>'
                + '</div>';
            $('body').append(htmls);
        },

        /**loading.gif
         * 取消等待
         */
        hideLoading: function () {
            // setTimeout(function () {
                $(".g-loading").remove();
            // }, 500);
        },
    // //去除数组中重复的
    unique: function(arr) {
        var result = [],
            hash = {};
        for (var i = 0, elem;
            (elem = arr[i]) != null; i++) {
            if (!hash[elem]) {
                result.push(elem);
                hash[elem] = true;
            }
        }
        return result;
    },
    // //rem
    adaptive: function() {
        var screenWid = 0;
        var documentElementClientWidth = document.documentElement.clientWidth;
        if (documentElementClientWidth) {
            screenWid = document.documentElement.clientWidth;
        } else {
            screenWid = window.screen.width;
        }

        var fixWid = 375;
        screenWid = screenWid > 750 ? 750 : screenWid;
        var htmlFontSize = (screenWid / fixWid) * 20;
        document.documentElement.style.fontSize = htmlFontSize + 'px';
        window.addEventListener('resize', function() {
            utils.adaptive()
        })

    },
    getUrlStr: function(name){
        /**
         * 获取地址栏参数
         */
        let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)","i");
        if(reg.test(window.location.href)){
            return unescape(RegExp.$2.replace(/\+/g," "))
        }
        return undefined
    },
    awakeAPP: function() {
        // 唤起APP
        if (this.isAndroid()) {
            window.location.href = "https://lnk0.com/dMV5Q9"; //获得下载链接
        } else if (this.isIos()) {
            window.location.href = "itms-apps://itunes.apple.com/cn/app/jie-zou-da-shi/id1263000607?mt=8"; //获得下载链接
        }
        
    },
    goToApp:function(cmd, param) {
        console.log(cmd+ ":" +param)
        //跟app的交互
        window.location = cmd + ":" + param; // iOS接口调用
        window.JavaScriptHelper.sendCommand(cmd, param); // java接口调用

    },
    parse:function(strDes) {
        var obj = {};
        strDes.replace(/(\w+)(?:=([^&]*))?/g, function (str, key, value) {
            obj[key] = value;
        });
        return obj;
    },
    getParams: function(name){
        /**
         * 获取ua中的参数(日记与小店通用)
         */
         if(this.ua.includes('---?')){ //新版本
             const queryStr = this.ua.split('---?')[1]
             const queryObj = queryStr ? this.parse(queryStr) : {}
             console.log(queryStr,queryObj)
             return queryObj[name]
         } else{//旧方法
            if(name == 'token') return this.ua.split('token/')[1].split('hsVerison/')[0] 
            else if(name == 'hsVerison') return  (this.ua.includes('deviceid')? this.ua.split('hsVerison/')[1].split('deviceid')[0] : this.ua.split('hsVerison/')[1]  )
            else if(name == 'deviceid') return this.ua.split('deviceid/')[1] 
            else return undefined
         }
    },
    

};
exports = module.exports = utils;



// WEBPACK FOOTER //
// ./src/assets/js/utils.js